import { render, staticRenderFns } from "./Lessonplans.vue?vue&type=template&id=5c626a9d"
import script from "./Lessonplans.vue?vue&type=script&lang=js"
export * from "./Lessonplans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports